// styles
import Field from '../../../forms/field/field'
import styles from './action-card.module.scss'

export type ActionCardProps = {
	readonly className?: string
	readonly description: string
	readonly name: string
	readonly recommended?: boolean
	readonly title?: string
}

const ActionCard = ({
	className,
	description,
	name,
	recommended = false,
	title,
}: ActionCardProps): JSX.Element => {
	return (
		<div
			className={[styles.actionCard, className].join(' ').trim()}
			data-theme={recommended ? 'recommended' : undefined}
		>
			{title && <h3>{title}</h3>}
			<div
				className={styles.description}
				dangerouslySetInnerHTML={{ __html: description }}
			></div>

			<div className={styles.footer}>
				<div className={styles.tag}>
					{`${!recommended ? 'Other Option' : 'Recommended'}`}
				</div>

				<div className={styles.radios}>
					<Field
						type="radio"
						name={name}
						value="agree"
						label="Agree"
					/>
					<Field
						type="radio"
						name={name}
						value="disagree"
						label="Disagree"
					/>
				</div>
			</div>
		</div>
	)
}

export default ActionCard
